import type {ReactAction} from '@netx/core/bootstrap';
import {dispatcher} from '@netx/core-next/instance/dispatcher';
import {faCube} from '@netx/core-icons';
import {canCreateTMSObjectPackageFromSavedCart} from '../enablers';
import {CART_SAVED_ACTION_LABELS} from '../locales';
import {type ISavedCart} from '../schema';
import {CART_SAVED_EVENT} from './constants';

export const cartSavedActionCreateTMSObjectPackageIcon = faCube;

/**
 * Create tms object package from saved cart assets
 * @param params
 * @returns Action
 */
export const cartSavedActionCreateTMSObjectPackage = (
	savedCart?: ISavedCart,
	params: Partial<ReactAction> = {},
): ReactAction => ({
	name: 'saved-cart-create-tms-object-package',
	cb: () =>
		dispatcher.trigger(CART_SAVED_EVENT.CREATE_TMS_OBJECT_PACKAGE, savedCart),
	enableTest: () => canCreateTMSObjectPackageFromSavedCart(savedCart),
	icon: cartSavedActionCreateTMSObjectPackageIcon,
	get label() {
		return CART_SAVED_ACTION_LABELS.CREATE_TMS_OBJECT_PACKAGE;
	},
	...params,
});

export default cartSavedActionCreateTMSObjectPackage;
